import { isNativeWebViewPageUnloading } from './nativeWebViewLifecycle';

export type NativeGeolocationPushListener = (
  position: GeolocationPosition,
) => void;

const listeners = new Set<NativeGeolocationPushListener>();

/**
 * Subscribe to coordinates delivered by the native host via `globalThis.window.getLocation(lat, lng[, accuracy])`
 * (WKWebView / managed-browser pattern). Forwards into the same `GeolocationPosition` pipeline as
 * `navigator.geolocation` inside `useGeoLocation`.
 *
 * @returns Unsubscribe function.
 */
export function subscribeToNativeGeolocationPush(
  listener: NativeGeolocationPushListener,
): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}

/**
 * Delivers a host-pushed position to all subscribers. Used only from
 * `patchGetLocationGlobalIfAbsent`.
 */
export function publishNativeGeolocationPosition(
  position: GeolocationPosition,
): void {
  if (isNativeWebViewPageUnloading()) {
    return;
  }

  for (const listener of listeners) {
    try {
      listener(position);
    } catch (error: unknown) {
      if (process.env['NODE_ENV'] !== 'production') {
        console.warn('Native geolocation subscriber threw', error);
      }
    }
  }
}
